module.exports = __webpack_public_path__ + "static/media/buy2.12a30212.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/buy/buy2.png
// module id = 974
// module chunks = 0